<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.17,13.93C13,14.08,12.84,14.22,12.71,14.37C12.58,14.53,12.49,14.69,12.44,14.86C12.44,14.86,15.99,14.86,15.99,14.86C15.99,14.86,15.99,16,15.99,16C15.99,16,11,16,11,16C11.01,15.35,11.16,14.78,11.44,14.29C11.72,13.8,12.11,13.38,12.61,13.02C12.85,12.84,13.1,12.66,13.36,12.48C13.61,12.3,13.85,12.12,14.07,11.91C14.28,11.71,14.46,11.49,14.6,11.26C14.74,11.02,14.81,10.75,14.82,10.44C14.82,10.3,14.8,10.15,14.77,9.99C14.74,9.83,14.68,9.68,14.59,9.54C14.5,9.4,14.37,9.28,14.22,9.19C14.06,9.1,13.85,9.05,13.59,9.05C13.35,9.05,13.16,9.1,13,9.2C12.84,9.3,12.71,9.44,12.62,9.62C12.52,9.79,12.45,10,12.41,10.24C12.36,10.48,12.34,10.74,12.33,11.01C12.33,11.01,11.14,11.01,11.14,11.01C11.14,10.58,11.19,10.18,11.3,9.81C11.41,9.44,11.57,9.12,11.79,8.85C12,8.6,12.27,8.39,12.58,8.23C12.89,8.08,13.25,8,13.65,8C14.1,8,14.47,8.08,14.76,8.23C15.06,8.39,15.31,8.59,15.49,8.83C15.68,9.07,15.81,9.33,15.88,9.62C15.96,9.9,16,10.16,16,10.41C16,10.72,15.96,11.01,15.87,11.26C15.78,11.51,15.65,11.75,15.5,11.96C15.35,12.17,15.18,12.37,14.98,12.55C14.78,12.73,14.58,12.9,14.37,13.06C14.16,13.21,13.95,13.36,13.74,13.51C13.53,13.65,13.35,13.79,13.17,13.93C13.17,13.93,13.17,13.93,13.17,13.93ZM0,1C0,0.45,0.44,0,1,0C1.55,0,2,0.46,2,1C2,1,2,11,2,11C2,11.55,1.56,12,1,12C0.45,12,0,11.54,0,11C0,11,0,1,0,1C0,1,0,1,0,1ZM6,1C6,0.45,6.44,0,7,0C7.55,0,8,0.46,8,1C8,1,8,11,8,11C8,11.55,7.56,12,7,12C6.45,12,6,11.54,6,11C6,11,6,1,6,1C6,1,6,1,6,1ZM2,5C2,5,6,5,6,5C6,5,6,7,6,7C6,7,2,7,2,7C2,7,2,5,2,5C2,5,2,5,2,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HeaderTwo',
} as DefineComponent
</script>
